
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE && window.flitsObjects.storeData.should_social_load){
    if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  // STORE CREDIT
  if (Flits.customer_id != -1 && Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable) {
   Flits.LoadStyleScript('cartJs', window.flitsObjects.allCssJs.cartJs.url);
  }
  
   Flits(document).on('Flits:AccountPage:Loaded', function(event){
     setInterval(function(){
       var data = event.detail;
       Flits.shopCountryName = 'Estonia';
     },1000);
  });
  
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
        document.addEventListener('click', function(event) {
                var flits_credit_added_attr = Flits(event.target).attr("data-flits");
                    if (typeof flits_credit_added_attr !== 'undefined' && flits_credit_added_attr == 'store-credit-added') {
                    var submitBtn = event.target;
                    return Flits.setupcheckoutProcess.apply(Flits.StoreCreditCart, [event, submitBtn]);          
                    }
        }, true);
  }
  
   function formatPhoneNumber(phoneNumberString) {
    var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = (match[1] ? '+1 ' : '');
      return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
    return null;
  }
  Flits(document).on('Flits:myProfile:Loaded', function(event){
    var newNum = formatPhoneNumber(Flits('#flits-form-profile .flits-input[name="phone"]').val());
    Flits('#flits-form-profile .flits-input[name="phone"]').val(newNum);
    var birthvalue = Flits('div[data-flits-birthdate]').attr('data-flits-birthdate');
    if(!birthvalue){
       Flits('#flits-form-profile .flits-input[name="birthdate"]').val('mm-dd-yyyy');
    }
  });
  Flits(document).on("click", ".flits-profile-edit-button", function () {
    var birthvalue = Flits('div[data-flits-birthdate]').attr('data-flits-birthdate');
    if(birthvalue){
      var originalDate = new Date(Flits('div[data-flits-birthdate]').attr('data-flits-birthdate'));
      Flits('#flits-form-profile .flits-input[name="birthdate"]').val(originalDate.toISOString().substr(0, 10));
    }
  });
  Flits(document).on("click", ".flits-profile-cancel-button", function () {
    var birthvalue = Flits('div[data-flits-birthdate]').attr('data-flits-birthdate');
    setTimeout(function(){
      if(birthvalue){
      var bdayArr = Flits('div[data-flits-birthdate]').attr('data-flits-birthdate').split("-");
      var newbdayArr = bdayArr[1] +"-"+ bdayArr[2] +"-"+ bdayArr[0];
      Flits('#flits-form-profile .flits-input[name="birthdate"]').val(newbdayArr);
      }
      else{
      	Flits('#flits-form-profile .flits-input[name="birthdate"]').val('mm-dd-yyyy');
      }
      var newNum = formatPhoneNumber(Flits('#flits-form-profile .flits-input[name="phone"]').val());
      Flits('#flits-form-profile .flits-input[name="phone"]').val(newNum);
    }, 500);
  });
  Flits(document).on("Flits:myProfile:Updated", function(event){
    setTimeout(function(){
      var birthvalue = Flits('div[data-flits-birthdate]').attr('data-flits-birthdate');
      if(birthvalue){
        var bdayArr = Flits('#flits-form-profile .flits-input[name="birthdate"]').val().split("-");
        var newbdayArr = bdayArr[1] +"-"+ bdayArr[2] +"-"+ bdayArr[0];
        Flits('#flits-form-profile .flits-input[name="birthdate"]').val(newbdayArr);
      }
      else{
      	Flits('#flits-form-profile .flits-input[name="birthdate"]').val('mm-dd-yyyy');
      }
      var newNum = formatPhoneNumber(Flits('#flits-form-profile .flits-input[name="phone"]').val());
      Flits('#flits-form-profile .flits-input[name="phone"]').val(newNum);
    }, 1000);
  });

  // Temp Way to resolve Credit apply at chechout page

  Flits.extend({
    redirectToCheckout: async function (parameters) {
      parameters = parameters || {};
      var form = Flits(Flits.StoreCreditCart.settings.checkoutFormSelectors.join(','));
      if (form.length <= 0) {
        // location.href = "/checkout?" + Flits.param(parameters);   
        location.href = location.origin+"/discount/"+parameters?.discount+"?redirect=/checkout";
        return true;
      }
      fetch(`/discount/${parameters?.discount}`)
        .then(function() {
            var form_action = form.attr("action");
            var form_action_data = Flits.parseURL(form_action);
      
            Flits.each(parameters, function (index, item) {
              var existing = form.find("[name='" + index + "']");
              if (existing.length <= 0) {
                form.append("<input type='hidden' name='" + index + "' value='" + item + "'>");
              } else {
                existing.val(item);
              }
              if (form_action_data.searchObject[index]) {
                form_action = form_action.replace(index + '=' + form_action_data.searchObject[index], item);
              } else {
                form_action += (form_action.indexOf('?') !== -1 ? "&" : "?") + index + "=" + item;
              }
            });
            form.append("<input type='hidden' name='checkout' value='true'>");
            form.attr("action", form_action);
            form.trigger('submit', [{ flitsFormSubmitted: true }]);
      });
    }
  })
  
}(Flits));
